import {
  USER_AUTHENTICATED,
  CLOSE_ANNOUNCEMENT,
  UPDATE_USER_LANG,
} from "../actions/UserActions";

export default (state = { ShowAnnouncement: true }, { type, payload }) => {
  switch (type) {
    case USER_AUTHENTICATED:
      return {
        ShowAnnouncement: true,
        ...payload,
        ...(!payload.isAuthenticated ? { invalidLogin: true } : {}),
      };
    case CLOSE_ANNOUNCEMENT:
      return {
        ...state,
        ...payload,
      };
    case UPDATE_USER_LANG:
      return { ...state, UserProfile: { ...state.UserProfile, ...payload } };
    default:
      return state;
  }
};
